export default "__VITE_ASSET__CPHr3ViA__"